import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/user-topic.svg'


const _hoisted_1 = { class: "w-full border-y border-neutral-300 max-w-[1344px]" }
const _hoisted_2 = { class: "py-10 max-w-[1112px] mx-auto" }
const _hoisted_3 = { class: "w-full h-4/5" }
const _hoisted_4 = { class: "flex items-center mb-6" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "object-cover w-12 h-12 mr-6 rounded-full cursor-pointer",
  src: _imports_0,
  alt: "user"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "text-base font-bold text-h-neutral-700" }
const _hoisted_11 = { class: "text-sm text-h-neutral-700" }
const _hoisted_12 = { class: "py-1 pl-2 pr-1 mb-3 text-base font-bold border-l-2 text-h-primary-500 border-h-primary-500 bg-neutral-100 w-fit" }
const _hoisted_13 = { class: "text-2xl font-medium leading-8 break-all" }
const _hoisted_14 = { class: "custom-quill" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 0,
  class: "!w-full flex justify-center bg-black mt-6"
}
const _hoisted_17 = { class: "flex justify-between mt-6 md:gap-3" }
const _hoisted_18 = { class: "grid grid-cols-2" }
const _hoisted_19 = { class: "flex justify-center items-center gap-2 text-h-primary-500" }
const _hoisted_20 = {
  key: 0,
  class: "text-base font-bold text-h-primary-500"
}
const _hoisted_21 = {
  key: 1,
  class: "text-base font-bold text-h-primary-500"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { class: "custom-dropdownforum flex flex-row justify-between items-center" }
const _hoisted_26 = {
  key: 0,
  class: "lg:hidden"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "text-base font-bold" }
const _hoisted_29 = { class: "lg:hidden" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "hidden lg:flex lg:gap-6" }
const _hoisted_32 = { class: "flex items-center cursor-pointer" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-xl font-medium text-h-neutral-900" }, " Fechar tópico? ")
], -1)
const _hoisted_34 = { class: "m-4 mt-8" }
const _hoisted_35 = { class: "text-base font-semibold leading-5 font text-neutral-900" }
const _hoisted_36 = { class: "flex flex-col p-4 pt-0" }
const _hoisted_37 = { class: "mb-4 flex items-center" }
const _hoisted_38 = {
  for: "solved",
  class: "ml-2"
}
const _hoisted_39 = { class: "font-bold" }
const _hoisted_40 = { class: "mb-4 flex" }
const _hoisted_41 = {
  for: "closed",
  class: "ml-2"
}
const _hoisted_42 = { class: "font-bold" }
const _hoisted_43 = {
  key: 0,
  href: "#box-comment"
}
const _hoisted_44 = { class: "btn-primary text-base w-[181px] h-8 rounded mt-6" }
const _hoisted_45 = {
  key: 1,
  class: "flex flex-row p-1 bg-h-success-50 gap-1 w-fit mt-[26px]"
}
const _hoisted_46 = { class: "text-h-success-500" }
const _hoisted_47 = {
  key: 2,
  class: "flex flex-row p-1 bg-h-neutral-300 gap-1 w-fit mt-[26px]"
}
const _hoisted_48 = { class: "text-h-neutral-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("header", _hoisted_4, [
          (!_ctx.topic?.userAuthor?.photoProfile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : (_ctx.topic.userAuthor.photoProfile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("img", {
                    class: "object-cover w-12 h-12 mr-6 rounded-full cursor-pointer",
                    src: _ctx.topic.userAuthor?.photoProfile.path,
                    alt: "user"
                  }, null, 8, _hoisted_9)
                ]))
              : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("h6", _hoisted_10, _toDisplayString(_ctx.topic?.userAuthor?.name), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("labels.generic", { pt: "Publicado", en: "Published" })) + " " + _toDisplayString(_ctx.timeSinceCreation), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.topic?.tag || "Placeholder"), 1)
        ]),
        _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.topic?.title), 1),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("p", {
            innerHTML: _ctx.topic?.description,
            class: "ql-editor !p-0 mt-4 text-[14px]"
          }, null, 8, _hoisted_15),
          (_ctx.topic?.media)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_Image, {
                  src: _ctx.topic.media.path,
                  alt: "topic image",
                  preview: "",
                  imageClass: "!w-full !object-cover !h-[600px] !min-h-[150px] !max-h-[450px] "
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("footer", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, [
              _createVNode(_component_v_icon, {
                name: "md-chatbubbleoutline-round",
                scale: "0.72"
              }),
              (_ctx.topic?.commentAmount === 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.topic.commentAmount) + " " + _toDisplayString(_ctx.$t("labels.generic", { pt: "comentário", en: "comment" })), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.topic?.commentAmount) + " " + _toDisplayString(_ctx.$t("labels.generic", { pt: "comentários", en: "comments" })), 1))
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["flex justify-center items-center gap-2 font-bold cursor-pointer", _ctx.topic?.userLiked ? 'text-h-secondary-600' : 'text-h-primary-500'
              ]),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.likeTopic && _ctx.likeTopic(...args)))
            }, [
              _createVNode(_component_v_icon, {
                name: "ri-thumb-up-line",
                scale: "0.875"
              }),
              (_ctx.topic?.likeAmount === 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.topic?.likeAmount) + " " + _toDisplayString(_ctx.$t("labels.generic", { pt: "curtida", en: "like" })), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.topic?.likeAmount) + " " + _toDisplayString(_ctx.$t("labels.generic", { pt: "curtidas", en: "likes" })), 1))
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              (_ctx.topicItems().length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createVNode(_component_Dropdown, {
                      dropdownIcon: "pi pi-ellipsis-v",
                      options: _ctx.topicItems(),
                      class: "mt-3"
                    }, {
                      option: _withCtx((SlotProps) => [
                        _createElementVNode("button", {
                          class: "flex gap-2 items-center w-[212px] btn-simple",
                          onClick: ($event: any) => (_ctx.methodHandler(SlotProps.option.method))
                        }, [
                          _createVNode(_component_v_icon, {
                            name: SlotProps.option.icon
                          }, null, 8, ["name"]),
                          _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t("labels.generic", {
                        pt: SlotProps.option.labelPT,
                        en: SlotProps.option.labelEN
                        })), 1)
                        ], 8, _hoisted_27)
                      ]),
                      _: 1
                    }, 8, ["options"])
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.topicItems(), (option) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("button", {
                        class: "flex gap-2 items-center justify-center cursor-pointer pr-4 btn-simple",
                        onClick: ($event: any) => (_ctx.methodHandler(option.method))
                      }, [
                        _createVNode(_component_v_icon, {
                          name: option.icon,
                          scale: "0.8"
                        }, null, 8, ["name"])
                      ], 8, _hoisted_30)
                    ]))
                  }), 256)),
              _createElementVNode("div", _hoisted_31, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topicItems(), (option) => {
                  return (_openBlock(), _createElementBlock("span", _hoisted_32, [
                    _createVNode(_component_Button, {
                      class: "text-base font-bold btn-simple !p-0",
                      onClick: ($event: any) => (_ctx.methodHandler(option.method))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          name: option.icon,
                          scale: "0.8",
                          class: "mr-2"
                        }, null, 8, ["name"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('labels.generic', { pt: option.labelPT, en: option.labelEN })), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                }), 256)),
                _createVNode(_component_ConfirmDialog, {
                  group: "templating",
                  style: { maxWidth: '490px' },
                  class: "custom-confirm-dialog w-11/12"
                }),
                _createVNode(_component_Dialog, {
                  modal: "",
                  group: "closeTopic",
                  visible: _ctx.closeTopicDialogVisible,
                  "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.closeTopicDialogVisible) = $event)),
                  style: { maxWidth: '540px'},
                  class: "w-11/12 custom-dialogForum text-h-neutral-900"
                }, {
                  header: _withCtx(() => [
                    _hoisted_33
                  ]),
                  footer: _withCtx(() => [
                    _createVNode(_component_Button, {
                      label: "Cancelar",
                      text: "",
                      severity: "secondary",
                      autofocus: "",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isCloseTopicDialogVisible(false))),
                      class: "h-8 btn-outline"
                    }),
                    _createVNode(_component_Button, {
                      label: "Fechar tópico",
                      outlined: "",
                      severity: "secondary",
                      autofocus: "",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.markTopicAsResolved())),
                      class: "h-8 py-4 btn-primary",
                      disabled: _ctx.isCloseTopicButtonDisabled()
                    }, null, 8, ["disabled"])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t("labels.generic", {
                      pt: "Selecione como você gostaria de classificar o tópico. Ao confirmar, o tópico será fechado para novos comentários",
                      en: "Select how you would like to classify the topic.Upon confirmation, the topic will be closed to new comments"})), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_RadioButton, {
                          modelValue: _ctx.selectedTopicStatus,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTopicStatus) = $event)),
                          inputId: "solved",
                          name: "solved",
                          value: "SOLVED"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", _hoisted_38, [
                          _createElementVNode("p", null, [
                            _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("labels.generic", {pt: "Marcar como resolvido - ", en: "Mark as resolved - "})), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Indicado para tópicos que tiveram a dúvida respondida no comentário.",
                            en: "Recommended for topics that had the question answered in the comment." })), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_RadioButton, {
                          modelValue: _ctx.selectedTopicStatus,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTopicStatus) = $event)),
                          inputId: "closed",
                          name: "closed",
                          value: "CLOSED"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", _hoisted_41, [
                          _createElementVNode("p", null, [
                            _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t("labels.generic", {pt: "Encerrar tópico - ", en: "Close topic - "})), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Indicado para tópicos inativos por muito tempo",
                            en: "Suitable for topics that have been inactive for a long time" })), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["visible"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          (_ctx.topicStatus() === 'ACTIVE')
            ? (_openBlock(), _createElementBlock("a", _hoisted_43, [
                _createElementVNode("button", _hoisted_44, _toDisplayString(_ctx.$t("labels.generic", { pt: "Adicionar comentário", en: "Add comment" })), 1)
              ]))
            : (_ctx.topicStatus() === 'SOLVED')
              ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                  _createVNode(_component_v_icon, { name: "fc-checkmark" }),
                  _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.$t("labels.generic", { pt: "TÓPICO RESOLVIDO", en: "SOLVED TOPIC" })), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_47, [
                  _createVNode(_component_v_icon, { name: "io-checkmark" }),
                  _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t("labels.generic", { pt: "TÓPICO ENCERRADO", en: "CLOSED TOPIC" })), 1)
                ]))
        ])
      ])
    ])
  ]))
}